import TeamLeave from '@/screens/TeamLeave';

export default function PrivateTeamTeamIdEditLeaveRoute() {
  return <TeamLeave />;
}
